import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalPaymentInstallmentComponent } from '@app/shared/components/modals/modal-payment-installment/modal-payment-installment.component';

@Component({
  selector: 'vc-product-installment',
  templateUrl: './product-installment.component.html',
  styleUrls: ['./product-installment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductInstallmentComponent implements OnInit {
  @Input()
  product: Product;
  public textInstallment: string;
  public isInstallmentPossible = false;
  public isClickable = false;
  public mnemonic: string;
  constructor(private router: Router, public modal: MatDialog) {}

  ngOnInit() {
    this.setInstallement();
  }

  setInstallement() {
    if (this.product && this.product.installment) {
      this.mnemonic = this.product.installment.mnemonic;
      switch (this.mnemonic) {
        case 'facilypay_oney':
        case 'klarna':
        case 'splitit':
        case 'pagantis':
          this.isClickable = true;
          break;
      }
      this.isInstallmentPossible = true;
      this.textInstallment = this.product.installment.description.replace(this.product.installment.iconPlaceholder, '');
    }
  }

  openPaymentInstallmentInfo(event) {
    const maxWidth = this.mnemonic === 'facilypay_oney' ? 1024 : 600;
    const config = {
      maxWidth: maxWidth,
      data: {
        payment: this.mnemonic
      }
    };
    switch (this.mnemonic) {
      case 'pagantis':
        this.router.navigate([this.product.installment.link]);
        break;
      case 'facilypay_oney':
      case 'klarna':
      case 'splitit':
        this.modal.open(ModalPaymentInstallmentComponent, config);
        break;
    }
  }
}
